import cx from 'classnames'

import styles from './LockIcon.module.scss'

const LockIcon = ({ hide = false }) => (
    !hide && <span className={cx('icon-admin', styles.lockIcon)}></span>
)

export default LockIcon
